(function () {
  "use strict";

  var BulkTitleVerifyPanel = {
    containerEl: null,
    assetSpecs: null,
    renderedCards: [],
    pendingAssets: {},
    existingAssets: {},
    suggestedAssets: {},
    tmdbCache: {},

    init: function (containerEl) {
      this.containerEl = containerEl;
      this.pendingAssets = {};
      this.existingAssets = {};
      this.suggestedAssets = {};
      this.tmdbCache = {};
      this.fetchAssetSpecs();
    },

    fetchAssetSpecs: function () {
      var self = this;
      fetch("/api/admin/bulk-titles/asset-specs", {
        method: "GET",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (json && json.data) {
            self.assetSpecs = json.data;
          }
        })
        .catch(function () {
          // Asset specs will be unavailable; slots won't render
        });
    },

    // Field catalog grouped into accordion sections
    FIELD_GROUPS: [
      {
        id: "basic", label: "Basic Info", open: false, fields: [
          { key: "t_title", label: "Title", type: "text", wide: true },
          { key: "__import_destination", label: "Destination", type: "dropdown_static",
            options: [
              { value: "SD", label: "Studio Dome" },
              { value: "SD for BST", label: "Studio Dome + Bloodstream" },
            ]
          },
          { key: "t_year_completed", label: "Year", type: "text" },
          { key: "t_runtime", label: "Runtime", type: "text" },
          { key: "t_language", label: "Language", type: "text" },
          { key: "t_title_type", label: "Title Type", type: "dropdown", optionsKey: "title_types" },
          { key: "t_rating", label: "Rating", type: "dropdown", optionsKey: "ratings" },
          { key: "t_original_format", label: "Format", type: "dropdown", optionsKey: "formats" },
        ]
      },
      {
        id: "synopsis", label: "Synopsis", open: false, fields: [
          { key: "t_short_synopsis", label: "Short Synopsis", type: "textarea", wide: true },
          { key: "t_medium_synopsis", label: "Medium Synopsis", type: "textarea", wide: true },
          { key: "t_long_synopsis", label: "Long Synopsis", type: "textarea", wide: true },
        ]
      },
      {
        id: "crew", label: "Cast & Crew", open: false, fields: [
          { key: "t_director", label: "Director", type: "text" },
          { key: "t_writer", label: "Writer", type: "text" },
          { key: "t_producer", label: "Producer", type: "text" },
          { key: "t_exec_producers", label: "Exec Producers", type: "text" },
          { key: "t_cast", label: "Cast", type: "text", wide: true },
        ]
      },
      {
        id: "catalog", label: "Catalog & Classification", open: false, fields: [
          { key: "t_status", label: "Status", type: "dropdown", optionsKey: "statuses" },
          { key: "t_internal_status", label: "Internal Status", type: "dropdown", optionsKey: "internal_statuses" },
          { key: "t_approval_status", label: "Approval", type: "dropdown", optionsKey: "approval_statuses" },
          { key: "t_genres", label: "Genres", type: "multiselect", optionsKey: "genres" },
          { key: "t_labels", label: "Labels", type: "multiselect", optionsKey: "labels" },
          { key: "t_territories", label: "Territories", type: "multiselect", optionsKey: "territories" },
        ]
      },
      {
        id: "financial", label: "Financial", open: false, fields: [
          { key: "t_sales_commission", label: "Sales Commission", type: "text" },
          { key: "t_distribution", label: "Distribution", type: "text" },
          { key: "t_advance", label: "Advance", type: "text" },
          { key: "t_flat_marketing", label: "Flat Marketing", type: "text" },
          { key: "t_interest", label: "Interest", type: "text" },
          { key: "t_cap", label: "Cap", type: "text" },
        ]
      },
      {
        id: "dates", label: "Dates & Availability", open: false, fields: [
          { key: "t_release_date", label: "Release Date", type: "text" },
          { key: "t_avail_start", label: "Avail Start", type: "text" },
          { key: "t_avail_end", label: "Avail End", type: "text" },
          { key: "t_exclusive", label: "Exclusive", type: "checkbox" },
        ]
      },
      {
        id: "links", label: "Links & Social", open: false, fields: [
          { key: "t_video_trailer_1", label: "Trailer URL", type: "text", wide: true },
          { key: "t_site", label: "Website", type: "text", wide: true },
          { key: "t_facebook", label: "Facebook", type: "text" },
          { key: "t_twitter", label: "Twitter", type: "text" },
          { key: "t_instagram", label: "Instagram", type: "text" },
        ]
      },
      {
        id: "notes", label: "Notes", open: false, fields: [
          { key: "t_notes", label: "Notes", type: "textarea", wide: true },
          { key: "t_internal_notes", label: "Internal Notes", type: "textarea", wide: true },
        ]
      },
    ],

    // Stored references for syncing edits back
    _sourceData: null,
    _rowMeta: null,
    _lookups: null,

    renderAll: function (sourceData, rowMeta, lookups) {
      if (!this.containerEl) {
        return;
      }

      this._sourceData = sourceData;
      this._rowMeta = rowMeta;
      this._lookups = lookups;

      // Stop any in-flight batch polling from previous render
      this.stopBatchPolling();
      this.hideBatchProgress();

      this.containerEl.textContent = "";
      this.renderedCards = [];
      this.existingAssets = {};

      // Populate existing assets from rowMeta
      if (rowMeta) {
        for (var m = 0; m < rowMeta.length; m++) {
          var rm = rowMeta[m];
          if (rm && rm.existing_assets) {
            var types = Object.keys(rm.existing_assets);
            for (var t = 0; t < types.length; t++) {
              this.existingAssets[m + ":" + types[t]] = rm.existing_assets[types[t]];
            }
          }
        }
      }

      if (!sourceData || sourceData.length === 0) {
        var empty = document.createElement("div");
        empty.style.cssText = "padding:2rem;text-align:center;color:#888;";
        empty.textContent =
          "No titles loaded. Switch to Spreadsheet view and fetch IMDB IDs first.";
        this.containerEl.appendChild(empty);
        return;
      }

      var hasAnyData = false;
      for (var i = 0; i < sourceData.length; i++) {
        var meta = rowMeta[i];
        if (!meta || !meta.imdb_id) {
          continue;
        }
        hasAnyData = true;
        var card = this.renderCard(i, sourceData[i], meta, lookups);
        card._renderData = { rowData: sourceData[i], meta: meta, lookups: lookups };
        this.containerEl.appendChild(card);
        this.renderedCards.push({ rowIndex: i, el: card });
      }

      if (!hasAnyData) {
        var noData = document.createElement("div");
        noData.style.cssText = "padding:2rem;text-align:center;color:#888;";
        noData.textContent =
          "No fetched titles to verify. Process some IMDB IDs in the Spreadsheet view first.";
        this.containerEl.appendChild(noData);
      } else {
        this.fetchSuggestionsForEmptySlots(sourceData, rowMeta);
      }
    },

    renderCard: function (rowIndex, rowData, meta, lookups) {
      var card = document.createElement("div");
      card.className = "bulk-verify-card";
      card.dataset.rowIndex = rowIndex;

      if (meta.mode === "create") {
        card.classList.add("verify-mode-create");
      } else if (meta.mode === "update") {
        card.classList.add("verify-mode-update");
      }
      if (meta.errors && meta.errors.length > 0) {
        card.classList.add("verify-mode-error");
      }

      card.appendChild(this.renderHeader(rowData, meta));
      card.appendChild(this.renderBody(rowData, meta, rowIndex));

      var destination = rowData.__import_destination || "SD";
      var assetsSection = this.renderAssetsSection(rowIndex, destination, meta);
      if (assetsSection) {
        card.appendChild(assetsSection);
      }

      if (meta.warnings && meta.warnings.length > 0) {
        card.appendChild(this.renderWarnings(meta));
      }

      return card;
    },

    renderHeader: function (rowData, meta) {
      var header = document.createElement("div");
      header.className = "bulk-verify-card-header";

      var badge = document.createElement("span");
      badge.className = "verify-status-badge";
      if (meta.mode === "create") {
        badge.classList.add("status-new");
        badge.textContent = "New";
      } else if (meta.mode === "update") {
        badge.classList.add("status-update");
        badge.textContent = "Update";
      }
      header.appendChild(badge);

      // Destination badge
      var dest = rowData.__import_destination || "SD";
      var destBadge = document.createElement("span");
      destBadge.className = "verify-status-badge";
      if (dest === "SD for BST") {
        destBadge.style.cssText = "background:#4a148c;color:#ce93d8;margin-left:4px;";
        destBadge.textContent = "Add to Studio Dome + Bloodstream";
      } else {
        destBadge.style.cssText = "background:#37474f;color:#b0bec5;margin-left:4px;";
        destBadge.textContent = "Add to Studio Dome";
      }
      header.appendChild(destBadge);

      var titleName = document.createElement("span");
      titleName.className = "verify-title-name";
      titleName.textContent = rowData.t_title || "(untitled)";
      header.appendChild(titleName);

      var year = document.createElement("span");
      year.className = "verify-title-year";
      year.textContent = rowData.t_year_completed || "";
      header.appendChild(year);

      return header;
    },

    renderBody: function (rowData, meta, rowIndex) {
      var body = document.createElement("div");
      body.className = "bulk-verify-card-body";

      var posterUrl = meta.poster_url;
      if (!posterUrl) {
        var sdPoster = this.existingAssets[rowIndex + ":studiodome_poster"];
        var bstPoster = this.existingAssets[rowIndex + ":bloodstream_poster"];
        if (sdPoster && sdPoster.url) posterUrl = sdPoster.url;
        else if (bstPoster && bstPoster.url) posterUrl = bstPoster.url;
      }

      body.appendChild(this.renderPosterArea(posterUrl));
      body.appendChild(this.renderMetadata(rowData, rowIndex));

      return body;
    },

    renderPosterArea: function (posterUrl) {
      var area = document.createElement("div");
      area.className = "verify-poster-area";

      if (posterUrl) {
        var img = document.createElement("img");
        img.src = posterUrl;
        img.alt = "Poster";
        img.loading = "lazy";
        area.appendChild(img);
      } else {
        var placeholder = document.createElement("div");
        placeholder.className = "verify-no-poster";
        placeholder.textContent = "No poster";
        area.appendChild(placeholder);
      }

      return area;
    },

    renderMetadata: function (rowData, rowIndex) {
      var section = document.createElement("div");
      section.className = "verify-meta-section";

      var groups = this.FIELD_GROUPS;
      for (var g = 0; g < groups.length; g++) {
        var group = groups[g];
        var accordion = this.renderAccordionGroup(group, rowData, rowIndex);
        section.appendChild(accordion);
      }

      return section;
    },

    renderAccordionGroup: function (group, rowData, rowIndex) {
      var wrapper = document.createElement("div");
      wrapper.className = "verify-accordion";
      if (group.open) wrapper.classList.add("is-open");

      var header = document.createElement("div");
      header.className = "verify-accordion-header";
      header.innerHTML = '<span class="accordion-chevron">&#9656;</span> ' + group.label;
      header.addEventListener("click", function () {
        wrapper.classList.toggle("is-open");
      });
      wrapper.appendChild(header);

      var body = document.createElement("div");
      body.className = "verify-accordion-body";

      var grid = document.createElement("div");
      grid.className = "verify-field-grid";

      var fields = group.fields;
      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        var value = rowData[field.key];
        if (value === undefined || value === null) value = "";

        var cell = document.createElement("div");
        cell.className = "verify-field-cell";
        if (field.wide) cell.classList.add("field-wide");

        var label = document.createElement("label");
        label.className = "verify-field-label";
        label.textContent = field.label;
        cell.appendChild(label);

        var input = this.createFieldInput(field, value, rowIndex);
        cell.appendChild(input);

        grid.appendChild(cell);
      }

      body.appendChild(grid);
      wrapper.appendChild(body);
      return wrapper;
    },

    createFieldInput: function (field, value, rowIndex) {
      var self = this;
      var el;

      if (field.type === "textarea") {
        el = document.createElement("textarea");
        el.value = typeof value === "string" ? value : String(value || "");
        el.rows = 2;
        el.style.cssText = "width:100%;background:#252540;color:#ddd;border:1px solid #3d3d5c;border-radius:3px;padding:4px 6px;font-size:12px;font-family:inherit;resize:vertical;";
        el.addEventListener("change", function () {
          self.syncFieldToGrid(rowIndex, field.key, el.value);
        });
      } else if (field.type === "dropdown_static") {
        el = document.createElement("select");
        el.style.cssText = "width:100%;background:#252540;color:#ddd;border:1px solid #3d3d5c;border-radius:3px;padding:4px 6px;font-size:12px;";
        var staticOpts = field.options || [];
        for (var si = 0; si < staticOpts.length; si++) {
          var sopt = document.createElement("option");
          sopt.value = staticOpts[si].value;
          sopt.textContent = staticOpts[si].label;
          if (String(staticOpts[si].value) === String(value)) sopt.selected = true;
          el.appendChild(sopt);
        }
        el.addEventListener("change", function () {
          self.syncFieldToGrid(rowIndex, field.key, el.value);
          // Refresh card to update destination badge and asset slots
          if (field.key === "__import_destination") {
            self.refreshCard(rowIndex);
          }
        });
      } else if (field.type === "dropdown") {
        el = document.createElement("select");
        el.style.cssText = "width:100%;background:#252540;color:#ddd;border:1px solid #3d3d5c;border-radius:3px;padding:4px 6px;font-size:12px;";
        var emptyOpt = document.createElement("option");
        emptyOpt.value = "";
        emptyOpt.textContent = "—";
        el.appendChild(emptyOpt);

        var options = this.getDropdownOptions(field.optionsKey);
        var strVal = String(value || "").toLowerCase();
        for (var i = 0; i < options.length; i++) {
          var opt = document.createElement("option");
          opt.value = options[i].value;
          opt.textContent = options[i].label;
          // Match by value, label, or case-insensitive label (HoT stores display labels)
          if (String(options[i].value) === String(value) ||
              String(options[i].label) === String(value) ||
              String(options[i].label).toLowerCase() === strVal) {
            opt.selected = true;
          }
          el.appendChild(opt);
        }
        el.addEventListener("change", function () {
          // Sync the display label to the grid (HoT uses labels)
          var selectedOpt = el.options[el.selectedIndex];
          self.syncFieldToGrid(rowIndex, field.key, selectedOpt ? selectedOpt.textContent : el.value);
        });
      } else if (field.type === "multiselect") {
        el = document.createElement("div");
        var displayVal = this.formatArrayField(value);
        var textInput = document.createElement("input");
        textInput.type = "text";
        textInput.value = displayVal || "";
        textInput.style.cssText = "width:100%;background:#252540;color:#ddd;border:1px solid #3d3d5c;border-radius:3px;padding:4px 6px;font-size:12px;";
        textInput.title = "Comma-separated values";
        textInput.addEventListener("change", function () {
          self.syncFieldToGrid(rowIndex, field.key, textInput.value);
        });
        el.appendChild(textInput);
      } else if (field.type === "checkbox") {
        el = document.createElement("input");
        el.type = "checkbox";
        el.checked = !!value && value !== "0" && value !== "false";
        el.style.cssText = "margin:4px 0;";
        el.addEventListener("change", function () {
          self.syncFieldToGrid(rowIndex, field.key, el.checked ? "1" : "0");
        });
      } else {
        el = document.createElement("input");
        el.type = "text";
        el.value = typeof value === "string" ? value : String(value || "");
        el.style.cssText = "width:100%;background:#252540;color:#ddd;border:1px solid #3d3d5c;border-radius:3px;padding:4px 6px;font-size:12px;";
        el.addEventListener("change", function () {
          self.syncFieldToGrid(rowIndex, field.key, el.value);
        });
      }

      return el;
    },

    getDropdownOptions: function (optionsKey) {
      if (!this._lookups || !optionsKey) return [];
      var source = this._lookups[optionsKey];
      if (!Array.isArray(source)) return [];
      return source.map(function (item) {
        if (item && typeof item === "object" && item.value !== undefined) {
          return { value: item.value, label: item.label || String(item.value) };
        }
        return { value: item, label: String(item) };
      });
    },

    syncFieldToGrid: function (rowIndex, fieldKey, newValue) {
      // Update local sourceData reference
      if (this._sourceData && this._sourceData[rowIndex]) {
        this._sourceData[rowIndex][fieldKey] = newValue;
      }

      // Sync back to HandsOnTable
      var importModule = window.BulkTitleImport;
      if (importModule && importModule.hot) {
        importModule.hot.setDataAtRowProp(rowIndex, fieldKey, newValue, "verify_edit");
      }

      // Update card header if title/year changed
      if (fieldKey === "t_title" || fieldKey === "t_year_completed") {
        var card = this.renderedCards.filter(function (c) { return c.rowIndex === rowIndex; })[0];
        if (card && card.el) {
          var titleEl = card.el.querySelector(".verify-title-name");
          var yearEl = card.el.querySelector(".verify-title-year");
          if (titleEl && fieldKey === "t_title") titleEl.textContent = newValue || "(untitled)";
          if (yearEl && fieldKey === "t_year_completed") yearEl.textContent = newValue || "";
        }
      }
    },

    renderAssetsSection: function (rowIndex, destination) {
      if (!this.assetSpecs) {
        return null;
      }

      var platform = this.getPlatformForDestination(destination);
      var specs = this.assetSpecs[platform];
      if (!specs || specs.length === 0) {
        return null;
      }

      var section = document.createElement("div");
      section.className = "verify-assets-section";

      var heading = document.createElement("div");
      heading.className = "verify-assets-heading";
      heading.textContent =
        "Assets (" +
        (platform === "bloodstream" ? "Bloodstream" : "Studio Dome") +
        ")";
      section.appendChild(heading);

      var grid = document.createElement("div");
      grid.className = "verify-asset-slots";

      for (var i = 0; i < specs.length; i++) {
        var slot = this.renderAssetSlot(rowIndex, specs[i]);
        grid.appendChild(slot);
      }

      section.appendChild(grid);
      return section;
    },

    renderAssetSlot: function (rowIndex, spec) {
      var self = this;
      var assetType = spec.type;
      var slotKey = rowIndex + ":" + assetType;
      var pending = this.pendingAssets[slotKey];
      var existing = this.existingAssets[slotKey];

      var slot = document.createElement("div");
      slot.className = "verify-asset-slot";
      slot.dataset.row = rowIndex;
      slot.dataset.type = assetType;
      if (pending || existing) {
        slot.classList.add("has-file");
      }

      // Preview thumbnail
      var preview = document.createElement("div");
      preview.className = "asset-slot-preview";
      if (pending && pending.previewUrl) {
        var img = document.createElement("img");
        img.src = pending.previewUrl;
        img.alt = spec.label;
        preview.appendChild(img);
      } else if (existing && existing.url) {
        var existImg = document.createElement("img");
        existImg.src = existing.url;
        existImg.alt = spec.label;
        preview.appendChild(existImg);
      } else {
        var ph = document.createElement("span");
        ph.className = "asset-slot-placeholder";
        ph.textContent = spec.width + "x" + spec.height;
        preview.appendChild(ph);
      }
      slot.appendChild(preview);

      // Info
      var info = document.createElement("div");
      info.className = "asset-slot-info";

      var label = document.createElement("div");
      label.className = "asset-slot-label";
      label.textContent = spec.label;
      info.appendChild(label);

      var dims = document.createElement("div");
      dims.className = "asset-slot-dims";
      dims.textContent =
        spec.width +
        " x " +
        spec.height +
        (spec.max_dimensions ? " (max)" : "");
      info.appendChild(dims);

      if (pending) {
        var status = document.createElement("div");
        status.className = "asset-slot-status";
        if (pending.uploaded) {
          status.classList.add("upload-success");
          status.textContent = "Uploaded";
        } else if (pending.error) {
          status.classList.add("upload-error");
          status.textContent = pending.error;
        } else {
          status.classList.add("upload-progress");
          status.textContent = "Uploading...";
        }
        info.appendChild(status);
      } else if (existing) {
        var existStatus = document.createElement("div");
        existStatus.className = "asset-slot-status upload-success";
        existStatus.textContent =
          "Current" +
          (existing.width && existing.height
            ? " (" + existing.width + "x" + existing.height + ")"
            : "");
        info.appendChild(existStatus);
      }
      slot.appendChild(info);

      // Actions
      var actions = document.createElement("div");
      actions.className = "asset-slot-actions";

      var fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/jpeg,image/png,image/webp";
      fileInput.dataset.rowIndex = rowIndex;
      fileInput.dataset.assetType = assetType;
      fileInput.addEventListener("change", function (e) {
        var file = e.target.files[0];
        if (file) {
          self.handleFileSelect(rowIndex, assetType, file, spec);
        }
      });
      actions.appendChild(fileInput);

      var browseBtn = document.createElement("button");
      browseBtn.className = "button small hollow";
      browseBtn.textContent = "Browse";
      browseBtn.addEventListener("click", function () {
        fileInput.click();
      });
      actions.appendChild(browseBtn);

      if (pending) {
        var removeBtn = document.createElement("button");
        removeBtn.className = "asset-remove-btn";
        removeBtn.textContent = "\u00d7";
        removeBtn.title = "Remove";
        removeBtn.addEventListener("click", function () {
          self.removePendingAsset(rowIndex, assetType);
        });
        actions.appendChild(removeBtn);
      }

      slot.appendChild(actions);

      // Drag and drop
      slot.addEventListener("dragenter", function (e) {
        e.preventDefault();
        slot.classList.add("drag-over");
      });
      slot.addEventListener("dragover", function (e) {
        e.preventDefault();
      });
      slot.addEventListener("dragleave", function () {
        slot.classList.remove("drag-over");
      });
      slot.addEventListener("drop", function (e) {
        e.preventDefault();
        slot.classList.remove("drag-over");
        var file =
          e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) {
          self.handleFileSelect(rowIndex, assetType, file, spec);
        }
      });

      return slot;
    },

    renderWarnings: function (meta) {
      var container = document.createElement("div");
      container.className = "verify-warnings";

      for (var i = 0; i < meta.warnings.length; i++) {
        var callout = document.createElement("div");
        callout.className = "callout warning";
        callout.textContent = meta.warnings[i];
        container.appendChild(callout);
      }

      return container;
    },

    handleFileSelect: function (rowIndex, assetType, file, spec) {
      var self = this;
      var slotKey = rowIndex + ":" + assetType;

      this.validateDimensions(file, spec)
        .then(function (result) {
          if (!result.valid) {
            self.pendingAssets[slotKey] = {
              file: null,
              previewUrl: null,
              uploaded: false,
              error: result.error,
            };
            self.refreshCard(rowIndex);
            return;
          }

          self.pendingAssets[slotKey] = {
            file: file,
            previewUrl: result.previewUrl,
            uploaded: false,
            error: null,
          };
          self.refreshCard(rowIndex);

          self.uploadTempAsset(rowIndex, assetType, file);
        })
        .catch(function () {
          self.pendingAssets[slotKey] = {
            file: null,
            previewUrl: null,
            uploaded: false,
            error: "Could not read image",
          };
          self.refreshCard(rowIndex);
        });
    },

    validateDimensions: function (file, spec) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var img = new Image();

        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.width;
          var h = img.height;
          var isMax = !!spec.max_dimensions;

          if (isMax) {
            if (w > spec.width || h > spec.height) {
              resolve({
                valid: false,
                error:
                  "Exceeds max " +
                  spec.width +
                  "x" +
                  spec.height +
                  " (got " +
                  w +
                  "x" +
                  h +
                  ")",
              });
              return;
            }
          }

          resolve({
            valid: true,
            previewUrl: URL.createObjectURL(file),
            width: w,
            height: h,
          });
        };

        img.onerror = function () {
          URL.revokeObjectURL(url);
          resolve({ valid: false, error: "Could not read image" });
        };

        img.src = url;
      });
    },

    uploadTempAsset: function (rowIndex, assetType, file) {
      var self = this;
      var slotKey = rowIndex + ":" + assetType;
      var sessionEl = document.getElementById("bulk-title-session-id");
      var sessionId = sessionEl ? sessionEl.value : "";

      if (!sessionId) {
        if (self.pendingAssets[slotKey]) {
          self.pendingAssets[slotKey].error = "No session ID";
          self.pendingAssets[slotKey].uploaded = false;
        }
        self.refreshCard(rowIndex);
        return;
      }

      var formData = new FormData();
      formData.append("file", file);
      formData.append("session_id", sessionId);
      formData.append("row_id", String(rowIndex));
      formData.append("asset_type", assetType);

      fetch("/api/admin/bulk-titles/upload-asset", {
        method: "POST",
        credentials: "same-origin",
        body: formData,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          if (json && json.data) {
            if (self.pendingAssets[slotKey]) {
              self.pendingAssets[slotKey].uploaded = true;
              self.pendingAssets[slotKey].error = null;
              if (json.data.preview_url) {
                self.pendingAssets[slotKey].previewUrl = json.data.preview_url;
              }
            }
          } else {
            // The API's refusals come back as { success: false, message }.
            var msg = (json && (json.message || json.error)) || "Upload failed";
            if (self.pendingAssets[slotKey]) {
              self.pendingAssets[slotKey].error = msg;
            }
          }
          self.refreshCard(rowIndex);
        })
        .catch(function () {
          if (self.pendingAssets[slotKey]) {
            self.pendingAssets[slotKey].error = "Upload failed";
          }
          self.refreshCard(rowIndex);
        });
    },

    removePendingAsset: function (rowIndex, assetType) {
      var slotKey = rowIndex + ":" + assetType;
      delete this.pendingAssets[slotKey];
      this.refreshCard(rowIndex);
    },

    refreshCard: function (rowIndex) {
      for (var i = 0; i < this.renderedCards.length; i++) {
        if (this.renderedCards[i].rowIndex === rowIndex) {
          var oldCard = this.renderedCards[i].el;
          if (oldCard && oldCard.parentNode && oldCard._renderData) {
            var newCard = this.renderCard(
              rowIndex,
              oldCard._renderData.rowData,
              oldCard._renderData.meta,
              oldCard._renderData.lookups
            );
            newCard._renderData = oldCard._renderData;
            oldCard.parentNode.replaceChild(newCard, oldCard);
            this.renderedCards[i].el = newCard;
          }
          return;
        }
      }
    },

    getPlatformForDestination: function (destination) {
      if (!destination) {
        return "studiodome";
      }
      var d = destination.toLowerCase();
      if (d.indexOf("bst") !== -1 || d.indexOf("bloodstream") !== -1) {
        return "bloodstream";
      }
      return "studiodome";
    },

    formatArrayField: function (value) {
      if (!value) {
        return null;
      }
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      if (typeof value === "string") {
        try {
          var parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return parsed.join(", ");
          }
        } catch (e) {
          // not JSON
        }
        return value;
      }
      return String(value);
    },

    formatTitleType: function (value) {
      var types = {
        1: "Film",
        2: "Season",
        3: "Episode",
        4: "Short",
        5: "Music Video",
        6: "Trailer",
        7: "Show",
      };
      return types[value] || null;
    },

    // ---- Batch TMDB fetch (async jobs with polling) ----

    _batchPollTimer: null,
    _batchSessionId: null,
    _batchRowMap: null, // { imdb_id -> [{ rowIndex, types }] }
    _lastAppliedCount: 0,

    fetchSuggestionsForEmptySlots: function (sourceData, rowMeta) {
      if (!this.assetSpecs) return;

      // Collect items that need TMDB images, grouped by imdb_id
      var itemMap = {}; // imdb_id -> { types: Set, rows: [rowIndex] }
      var rowTypeMap = {}; // imdb_id -> [{ rowIndex, types: [] }]

      for (var i = 0; i < this.renderedCards.length; i++) {
        var entry = this.renderedCards[i];
        var ri = entry.rowIndex;
        var meta = rowMeta[ri];
        if (!meta || !meta.imdb_id) continue;

        var destination = sourceData[ri]
          ? sourceData[ri].__import_destination || "SD"
          : "SD";
        var platform = this.getPlatformForDestination(destination);
        var specs = this.assetSpecs[platform];
        if (!specs) continue;

        var neededTypes = [];
        for (var s = 0; s < specs.length; s++) {
          var spec = specs[s];
          var slotKey = ri + ":" + spec.type;
          if (this.pendingAssets[slotKey] || this.existingAssets[slotKey]) continue;

          // Check tmdb cache first
          var cacheKey = meta.imdb_id + ":" + spec.type;
          if (this.tmdbCache[cacheKey] !== undefined) {
            if (this.tmdbCache[cacheKey]) {
              this.applySuggestion(ri, spec.type, this.tmdbCache[cacheKey]);
            }
            continue;
          }

          neededTypes.push(spec.type);
        }

        if (neededTypes.length === 0) continue;

        if (!itemMap[meta.imdb_id]) {
          itemMap[meta.imdb_id] = { types: {}, rows: [] };
          rowTypeMap[meta.imdb_id] = [];
        }
        for (var t = 0; t < neededTypes.length; t++) {
          itemMap[meta.imdb_id].types[neededTypes[t]] = true;
        }
        itemMap[meta.imdb_id].rows.push(ri);
        rowTypeMap[meta.imdb_id].push({ rowIndex: ri, types: neededTypes });
      }

      // Build items array for the batch endpoint
      var items = [];
      var imdbIds = Object.keys(itemMap);
      for (var k = 0; k < imdbIds.length; k++) {
        items.push({
          imdb_id: imdbIds[k],
          types: Object.keys(itemMap[imdbIds[k]].types),
        });
      }

      if (items.length === 0) return;

      this._batchRowMap = rowTypeMap;
      this._lastAppliedCount = 0;
      this.dispatchBatchFetch(items);
    },

    dispatchBatchFetch: function (items) {
      var self = this;
      // Get session_id from the page
      var sessionEl = document.getElementById("bulk-title-session-id");
      var sessionId = sessionEl ? sessionEl.value : "tmdb_" + Date.now();
      this._batchSessionId = sessionId + "_tmdb";

      // Show progress indicator
      this.showBatchProgress(0, items.length, "Fetching TMDB images...");

      fetch("/api/admin/bulk-titles/tmdb-batch-fetch", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          session_id: this._batchSessionId,
          items: items,
        }),
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (json && json.data && json.data.status === "dispatched") {
            // Start polling for results
            self.startBatchPolling();
          } else {
            self.showBatchProgress(0, 0, "Failed to start TMDB fetch");
          }
        })
        .catch(function (err) {
          self.showBatchProgress(0, 0, "Error: " + (err.message || "network error"));
        });
    },

    startBatchPolling: function () {
      var self = this;
      // Clear any existing poll timer
      if (this._batchPollTimer) {
        clearInterval(this._batchPollTimer);
      }
      this._batchPollTimer = setInterval(function () {
        self.pollBatchStatus();
      }, 2000);
    },

    stopBatchPolling: function () {
      if (this._batchPollTimer) {
        clearInterval(this._batchPollTimer);
        this._batchPollTimer = null;
      }
    },

    pollBatchStatus: function () {
      var self = this;
      if (!this._batchSessionId) {
        this.stopBatchPolling();
        return;
      }

      fetch(
        "/api/admin/bulk-titles/tmdb-batch-status?session_id=" +
          encodeURIComponent(this._batchSessionId),
        { method: "GET", credentials: "same-origin", headers: { Accept: "application/json" } }
      )
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (!json || !json.data) return;
          var data = json.data;

          // Update progress bar
          self.showBatchProgress(data.completed || 0, data.total || 0,
            data.status === "completed"
              ? "TMDB images loaded"
              : "Fetching TMDB images... (" + (data.completed || 0) + "/" + (data.total || 0) + ")"
          );

          // Apply any new results
          if (data.results) {
            self.applyBatchResults(data.results);
          }

          // Stop polling when done
          if (data.status === "completed" || data.status === "failed") {
            self.stopBatchPolling();
            // Hide progress after a delay
            setTimeout(function () { self.hideBatchProgress(); }, 3000);
          }
        })
        .catch(function () {
          // Don't stop polling on transient errors
        });
    },

    applyBatchResults: function (results) {
      if (!this._batchRowMap) return;
      var imdbIds = Object.keys(results);

      for (var i = 0; i < imdbIds.length; i++) {
        var imdbId = imdbIds[i];
        var typeResults = results[imdbId];
        if (!typeResults || !this._batchRowMap[imdbId]) continue;

        var rowEntries = this._batchRowMap[imdbId];
        var types = Object.keys(typeResults);

        for (var t = 0; t < types.length; t++) {
          var assetType = types[t];
          var data = typeResults[assetType];
          var cacheKey = imdbId + ":" + assetType;

          // Skip if already cached
          if (this.tmdbCache[cacheKey] !== undefined) continue;

          if (data && data.images && data.images.length > 0) {
            var best = data.best || data.images[0];
            this.tmdbCache[cacheKey] = {
              url: best.url,
              thumb: best.thumb || best.url,
              width: best.width,
              height: best.height,
              source: best.source || "tmdb",
              allImages: data.images,
            };

            // Apply to all rows that use this imdb_id
            for (var r = 0; r < rowEntries.length; r++) {
              var re = rowEntries[r];
              if (re.types.indexOf(assetType) !== -1) {
                this.applySuggestion(re.rowIndex, assetType, this.tmdbCache[cacheKey]);
              }
            }
          } else {
            this.tmdbCache[cacheKey] = null;
          }
        }
      }
    },

    showBatchProgress: function (completed, total, message) {
      var bar = this.containerEl
        ? this.containerEl.parentNode.querySelector(".tmdb-batch-progress")
        : null;
      if (!bar) {
        bar = document.createElement("div");
        bar.className = "tmdb-batch-progress";
        bar.style.cssText =
          "padding:0.5rem 1rem;background:#1a1a2e;border:1px solid #2d2d44;" +
          "border-radius:4px;margin-bottom:0.75rem;display:flex;align-items:center;gap:0.75rem;";
        if (this.containerEl && this.containerEl.parentNode) {
          this.containerEl.parentNode.insertBefore(bar, this.containerEl);
        }
      }
      var pct = total > 0 ? Math.round((completed / total) * 100) : 0;
      bar.innerHTML =
        '<div class="ht-spinner" style="flex-shrink:0;' +
        (completed >= total && total > 0 ? "display:none;" : "") +
        '"></div>' +
        '<div style="flex:1;min-width:0;">' +
        '<div style="font-size:13px;color:#ccc;margin-bottom:4px;">' +
        (message || "Loading...") +
        "</div>" +
        '<div style="height:4px;background:#2d2d44;border-radius:2px;overflow:hidden;">' +
        '<div style="height:100%;background:#6c63ff;border-radius:2px;transition:width 0.3s;width:' +
        pct + '%;"></div>' +
        "</div>" +
        "</div>";
      bar.style.display = "flex";
    },

    hideBatchProgress: function () {
      var bar = this.containerEl
        ? this.containerEl.parentNode.querySelector(".tmdb-batch-progress")
        : null;
      if (bar) {
        bar.style.display = "none";
      }
    },

    /**
     * Fetch TMDB suggestion for a single slot (used by image picker fallback).
     * Kept for direct per-slot fetches when the user triggers manually.
     */
    fetchTmdbSuggestion: function (rowIndex, imdbId, spec) {
      var self = this;
      var cacheKey = imdbId + ":" + spec.type;

      if (this.tmdbCache[cacheKey] !== undefined) {
        if (this.tmdbCache[cacheKey]) {
          this.applySuggestion(rowIndex, spec.type, this.tmdbCache[cacheKey]);
        }
        return;
      }

      fetch(
        "/api/admin/bulk-titles/tmdb-images?imdb_id=" +
          encodeURIComponent(imdbId) +
          "&type=" +
          encodeURIComponent(spec.type),
        { method: "GET", credentials: "same-origin", headers: { Accept: "application/json" } }
      )
        .then(function (res) { return res.json(); })
        .then(function (json) {
          var images =
            json && json.data && json.data.images ? json.data.images : [];
          if (images.length > 0) {
            var best = images[0];
            self.tmdbCache[cacheKey] = {
              url: best.url,
              thumb: best.thumb || best.url,
              width: best.width,
              height: best.height,
              source: best.source || "tmdb",
              allImages: images,
            };
            self.applySuggestion(rowIndex, spec.type, self.tmdbCache[cacheKey]);
          } else {
            self.tmdbCache[cacheKey] = null;
          }
        })
        .catch(function () {
          self.tmdbCache[cacheKey] = null;
        });
    },

    applySuggestion: function (rowIndex, assetType, suggestion) {
      var slotKey = rowIndex + ":" + assetType;
      // Don't overwrite pending or existing
      if (this.pendingAssets[slotKey] || this.existingAssets[slotKey]) return;
      this.suggestedAssets[slotKey] = suggestion;
      this.updateSlotWithSuggestion(rowIndex, assetType, suggestion);
    },

    updateSlotWithSuggestion: function (rowIndex, assetType, suggestion) {
      var slot = this.containerEl.querySelector(
        '.verify-asset-slot[data-row="' + rowIndex + '"][data-type="' + assetType + '"]'
      );
      if (!slot) return;

      slot.classList.add("has-suggestion");

      // Update preview thumbnail using w300 thumb
      var preview = slot.querySelector(".asset-slot-preview");
      if (preview) {
        preview.innerHTML = "";
        var img = document.createElement("img");
        img.src = suggestion.thumb || suggestion.url;
        img.alt = assetType;
        img.style.opacity = "0.75";
        preview.appendChild(img);

        // Hover tooltip: show full-size image
        this.attachHoverPreview(preview, suggestion.url);

        // Click to open crop modal
        var self = this;
        preview.style.cursor = "pointer";
        preview.addEventListener("click", function () {
          self.showCropModal(rowIndex, assetType, suggestion);
        });
      }

      // Add suggestion status
      var info = slot.querySelector(".asset-slot-info");
      var existingStatus = info ? info.querySelector(".asset-slot-status") : null;
      if (existingStatus) existingStatus.remove();

      if (info) {
        var status = document.createElement("div");
        status.className = "asset-slot-status suggestion-status";
        status.textContent =
          "From " + (suggestion.source === "imdb" ? "IMDB" : "TMDB") +
          (suggestion.width && suggestion.height
            ? " (" + suggestion.width + "x" + suggestion.height + ")"
            : "");
        info.appendChild(status);
      }

      // Render inline image strip if multiple images available
      if (suggestion.allImages && suggestion.allImages.length > 1) {
        this.renderImageStrip(slot, rowIndex, assetType, suggestion.allImages);
      }
    },

    attachHoverPreview: function (el, fullUrl) {
      var tooltip = null;
      el.addEventListener("mouseenter", function (e) {
        tooltip = document.createElement("div");
        tooltip.className = "asset-hover-tooltip";
        var img = document.createElement("img");
        img.src = fullUrl;
        tooltip.appendChild(img);
        document.body.appendChild(tooltip);
        var rect = el.getBoundingClientRect();
        tooltip.style.left = rect.right + 8 + "px";
        tooltip.style.top = Math.max(8, rect.top - 60) + "px";
      });
      el.addEventListener("mousemove", function (e) {
        if (tooltip) {
          var rect = el.getBoundingClientRect();
          tooltip.style.left = rect.right + 8 + "px";
          tooltip.style.top = Math.max(8, rect.top - 60) + "px";
        }
      });
      el.addEventListener("mouseleave", function () {
        if (tooltip) { tooltip.remove(); tooltip = null; }
      });
    },

    renderImageStrip: function (slot, rowIndex, assetType, images) {
      // Remove existing strip
      var old = slot.querySelector(".asset-image-strip");
      if (old) old.remove();

      var strip = document.createElement("div");
      strip.className = "asset-image-strip";

      var self = this;
      var max = Math.min(images.length, 12);
      for (var i = 0; i < max; i++) {
        (function (img, idx) {
          var thumb = document.createElement("div");
          thumb.className = "strip-thumb";
          if (idx === 0) thumb.classList.add("strip-selected");

          var imgEl = document.createElement("img");
          imgEl.src = img.thumb || img.url;
          imgEl.alt = (idx + 1) + "/" + images.length;
          thumb.appendChild(imgEl);

          // Hover preview
          self.attachHoverPreview(thumb, img.url);

          // Click to select this image
          thumb.addEventListener("click", function () {
            var slotKey = rowIndex + ":" + assetType;
            self.suggestedAssets[slotKey] = {
              url: img.url,
              thumb: img.thumb || img.url,
              width: img.width,
              height: img.height,
              source: img.source || "tmdb",
              allImages: images,
            };
            // Update main preview
            var preview = slot.querySelector(".asset-slot-preview img");
            if (preview) preview.src = img.thumb || img.url;
            // Update selected state
            var all = strip.querySelectorAll(".strip-thumb");
            for (var j = 0; j < all.length; j++) all[j].classList.remove("strip-selected");
            thumb.classList.add("strip-selected");
          });

          strip.appendChild(thumb);
        })(images[i], i);
      }

      if (images.length > max) {
        var more = document.createElement("div");
        more.className = "strip-thumb strip-more";
        more.textContent = "+" + (images.length - max);
        more.title = "View all " + images.length + " images";
        more.addEventListener("click", function () {
          self.showImagePicker(rowIndex, assetType, images);
        });
        strip.appendChild(more);
      }

      slot.appendChild(strip);
    },

    showImagePicker: function (rowIndex, assetType, images) {
      var existing = document.querySelector(".bulk-import-image-picker");
      if (existing) existing.remove();

      var overlay = document.createElement("div");
      overlay.className = "bulk-import-image-picker";

      var panel = document.createElement("div");
      panel.className = "image-picker-panel";

      var header = document.createElement("div");
      header.className = "image-picker-header";
      header.innerHTML =
        '<span class="image-picker-title">Select Image (' +
        images.length + " available)</span>";

      var closeBtn = document.createElement("button");
      closeBtn.className = "button small hollow";
      closeBtn.textContent = "Close";
      closeBtn.addEventListener("click", function () { overlay.remove(); });
      header.appendChild(closeBtn);
      panel.appendChild(header);

      var grid = document.createElement("div");
      grid.className = "image-picker-grid";

      var self = this;
      for (var i = 0; i < images.length; i++) {
        (function (img, idx) {
          var item = document.createElement("div");
          item.className = "image-picker-item";
          if (idx === 0) item.classList.add("selected");

          var imgEl = document.createElement("img");
          imgEl.src = img.thumb || img.url;
          imgEl.alt = "Option " + (idx + 1);
          item.appendChild(imgEl);

          self.attachHoverPreview(item, img.url);

          var dims = document.createElement("div");
          dims.className = "image-picker-dims";
          dims.textContent =
            (img.width || "?") + "x" + (img.height || "?") +
            " - " + (img.source || "tmdb");
          item.appendChild(dims);

          item.addEventListener("click", function () {
            var slotKey = rowIndex + ":" + assetType;
            self.suggestedAssets[slotKey] = {
              url: img.url,
              thumb: img.thumb || img.url,
              width: img.width,
              height: img.height,
              source: img.source || "tmdb",
              allImages: images,
            };
            self.updateSlotWithSuggestion(rowIndex, assetType, self.suggestedAssets[slotKey]);
            overlay.remove();
          });

          grid.appendChild(item);
        })(images[i], i);
      }

      panel.appendChild(grid);
      overlay.appendChild(panel);

      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) overlay.remove();
      });

      document.body.appendChild(overlay);
    },

    showCropModal: function (rowIndex, assetType, suggestion) {
      var existing = document.querySelector(".bulk-import-crop-modal");
      if (existing) existing.remove();

      var self = this;
      var overlay = document.createElement("div");
      overlay.className = "bulk-import-crop-modal";

      var panel = document.createElement("div");
      panel.className = "crop-modal-panel";

      // Header
      var header = document.createElement("div");
      header.className = "crop-modal-header";
      header.innerHTML = '<span class="crop-modal-title">Crop Image</span>';
      var closeBtn = document.createElement("button");
      closeBtn.className = "button small hollow";
      closeBtn.textContent = "Cancel";
      closeBtn.addEventListener("click", function () { overlay.remove(); });
      header.appendChild(closeBtn);
      panel.appendChild(header);

      // Canvas area
      var body = document.createElement("div");
      body.className = "crop-modal-body";

      var canvas = document.createElement("canvas");
      canvas.className = "crop-canvas";
      body.appendChild(canvas);
      panel.appendChild(body);

      // Footer with apply button
      var footer = document.createElement("div");
      footer.className = "crop-modal-footer";
      var applyBtn = document.createElement("button");
      applyBtn.className = "button success small";
      applyBtn.textContent = "Apply Crop";
      footer.appendChild(applyBtn);
      panel.appendChild(footer);

      overlay.appendChild(panel);
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) overlay.remove();
      });
      document.body.appendChild(overlay);

      // Load image and set up crop interaction
      var sourceImg = new Image();
      sourceImg.crossOrigin = "anonymous";
      sourceImg.onload = function () {
        var maxW = Math.min(800, window.innerWidth - 100);
        var maxH = Math.min(600, window.innerHeight - 200);
        var scale = Math.min(maxW / sourceImg.width, maxH / sourceImg.height, 1);
        var dispW = Math.round(sourceImg.width * scale);
        var dispH = Math.round(sourceImg.height * scale);
        canvas.width = dispW;
        canvas.height = dispH;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(sourceImg, 0, 0, dispW, dispH);

        // Crop box state (in display coordinates)
        var crop = { x: 0, y: 0, w: dispW, h: dispH };
        var dragging = null; // null, 'move', 'nw', 'ne', 'sw', 'se'
        var dragStart = {};

        function drawOverlay() {
          ctx.clearRect(0, 0, dispW, dispH);
          ctx.drawImage(sourceImg, 0, 0, dispW, dispH);
          // Dim outside crop
          ctx.fillStyle = "rgba(0,0,0,0.5)";
          ctx.fillRect(0, 0, dispW, crop.y);
          ctx.fillRect(0, crop.y, crop.x, crop.h);
          ctx.fillRect(crop.x + crop.w, crop.y, dispW - crop.x - crop.w, crop.h);
          ctx.fillRect(0, crop.y + crop.h, dispW, dispH - crop.y - crop.h);
          // Crop border
          ctx.strokeStyle = "#fff";
          ctx.lineWidth = 2;
          ctx.strokeRect(crop.x, crop.y, crop.w, crop.h);
          // Corner handles
          var hs = 8;
          ctx.fillStyle = "#fff";
          [[crop.x, crop.y], [crop.x + crop.w, crop.y],
           [crop.x, crop.y + crop.h], [crop.x + crop.w, crop.y + crop.h]].forEach(function (p) {
            ctx.fillRect(p[0] - hs / 2, p[1] - hs / 2, hs, hs);
          });
        }

        drawOverlay();

        function getHandle(mx, my) {
          var hs = 12;
          var corners = [
            { name: "nw", x: crop.x, y: crop.y },
            { name: "ne", x: crop.x + crop.w, y: crop.y },
            { name: "sw", x: crop.x, y: crop.y + crop.h },
            { name: "se", x: crop.x + crop.w, y: crop.y + crop.h },
          ];
          for (var c = 0; c < corners.length; c++) {
            if (Math.abs(mx - corners[c].x) < hs && Math.abs(my - corners[c].y) < hs) {
              return corners[c].name;
            }
          }
          if (mx > crop.x && mx < crop.x + crop.w && my > crop.y && my < crop.y + crop.h) {
            return "move";
          }
          return null;
        }

        canvas.addEventListener("mousedown", function (e) {
          var rect = canvas.getBoundingClientRect();
          var mx = e.clientX - rect.left;
          var my = e.clientY - rect.top;
          dragging = getHandle(mx, my);
          dragStart = { mx: mx, my: my, crop: { x: crop.x, y: crop.y, w: crop.w, h: crop.h } };
        });

        canvas.addEventListener("mousemove", function (e) {
          var rect = canvas.getBoundingClientRect();
          var mx = e.clientX - rect.left;
          var my = e.clientY - rect.top;

          if (!dragging) {
            var h = getHandle(mx, my);
            canvas.style.cursor = h === "move" ? "move" : h ? h + "-resize" : "crosshair";
            return;
          }

          var dx = mx - dragStart.mx;
          var dy = my - dragStart.my;
          var sc = dragStart.crop;

          if (dragging === "move") {
            crop.x = Math.max(0, Math.min(dispW - crop.w, sc.x + dx));
            crop.y = Math.max(0, Math.min(dispH - crop.h, sc.y + dy));
          } else if (dragging === "se") {
            crop.w = Math.max(20, Math.min(dispW - sc.x, sc.w + dx));
            crop.h = Math.max(20, Math.min(dispH - sc.y, sc.h + dy));
          } else if (dragging === "nw") {
            var nw = Math.max(20, sc.w - dx);
            var nh = Math.max(20, sc.h - dy);
            crop.x = sc.x + sc.w - nw;
            crop.y = sc.y + sc.h - nh;
            crop.w = nw;
            crop.h = nh;
            crop.x = Math.max(0, crop.x);
            crop.y = Math.max(0, crop.y);
          } else if (dragging === "ne") {
            crop.w = Math.max(20, Math.min(dispW - sc.x, sc.w + dx));
            var nh2 = Math.max(20, sc.h - dy);
            crop.y = sc.y + sc.h - nh2;
            crop.h = nh2;
            crop.y = Math.max(0, crop.y);
          } else if (dragging === "sw") {
            var nw2 = Math.max(20, sc.w - dx);
            crop.x = sc.x + sc.w - nw2;
            crop.w = nw2;
            crop.h = Math.max(20, Math.min(dispH - sc.y, sc.h + dy));
            crop.x = Math.max(0, crop.x);
          }

          drawOverlay();
        });

        document.addEventListener("mouseup", function onUp() {
          dragging = null;
          document.removeEventListener("mouseup", onUp);
        });

        applyBtn.addEventListener("click", function () {
          // Convert display coords back to source coords
          var sx = Math.round(crop.x / scale);
          var sy = Math.round(crop.y / scale);
          var sw = Math.round(crop.w / scale);
          var sh = Math.round(crop.h / scale);

          // Render cropped image to a data URL
          var outCanvas = document.createElement("canvas");
          outCanvas.width = sw;
          outCanvas.height = sh;
          var outCtx = outCanvas.getContext("2d");
          outCtx.drawImage(sourceImg, sx, sy, sw, sh, 0, 0, sw, sh);

          var croppedUrl = outCanvas.toDataURL("image/jpeg", 0.92);
          var slotKey = rowIndex + ":" + assetType;

          // Store as pending asset with the crop
          self.pendingAssets[slotKey] = {
            file: null,
            previewUrl: croppedUrl,
            uploaded: false,
            error: null,
            cropData: { sx: sx, sy: sy, sw: sw, sh: sh, sourceUrl: suggestion.url },
          };
          self.refreshCard(rowIndex);
          overlay.remove();
        });
      };
      sourceImg.src = suggestion.url;
    },

    getPendingAssetsForRow: function (rowIndex) {
      var result = {};
      var prefix = rowIndex + ":";
      for (var key in this.pendingAssets) {
        if (key.indexOf(prefix) === 0) {
          var assetType = key.substring(prefix.length);
          result[assetType] = this.pendingAssets[key];
        }
      }
      return result;
    },

    getAllPendingAssets: function () {
      return this.pendingAssets;
    },
  };

  window.BulkTitleVerifyPanel = BulkTitleVerifyPanel;
})();
